var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{style:({ height: `${_vm.wrapperHeight}px` })},[_c('Icon',{attrs:{"name":_vm.icon,"width":_vm.size || _vm.width,"height":_vm.size || _vm.height,"original":_vm.original,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }